<template>
  <div id="verify-tree-grid" class="grid-view">
    <div class="main-content">
      <search-item
        config-module="932"
        :reset="true"
        :custom-sim-query-placeholder="$t('Message.PleaseEnterTheWarehouseNumber')"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <div slot="operations">
          <!--查看-->
          <el-button no="look" :disabled="!selectedData" type="success" @click="toLook()">{{ $t('common.btn.look') }}</el-button>
          <!--入库-->
          <el-button v-if="$checkPermission(['button_FBAOverseaWarehousing_overSeaWarehousing'])" no="warehouseIn" :disabled="!selectedData" type="primary" @click="onWarehouseIn()">{{ $t('Warehouse.WarehouseIn') }}</el-button>
          <!--出库-->
          <el-button v-if="$checkPermission(['button_FBAOverseaWarehousing_overSeaoutBound'])" no="checklist" :disabled="!selectedData" type="primary" @click="onExWarehouse()">{{ $t('Warehouse.ExWarehouse') }}</el-button>
          <!--编辑-->
          <el-button v-if="$checkPermission(['button_FBAOverseaWarehousing_editOverSeaWarehouse'])" no="edit" :disabled="!selectedData" type="success" @click="editHandler()">{{ $t('SeaExport.Edit') }}</el-button>
          <!--删除-->
          <el-button v-if="$checkPermission(['button_FBAOverseaWarehousing_deleteOverSeaWarehouse'])" no="delete" :disabled="!selectedData" type="danger" @click="deleteHandler()">{{ $t('SeaExport.Delete') }}</el-button>
          <!--打印-->
          <el-button v-if="$checkPermission(['button_FBAOverseaWarehousing_printOverSeaWarehouse'])" no="print" :disabled="!selectedData" type="primary" @click="onPrintHandler()">{{ $t('SeaExport.print') }}</el-button>
          <!--统计-->
          <el-button v-if="$checkPermission(['button_FBAOverseaWarehousing_statisticalOverSea'])" no="statistics" type="primary" @click="statisticsPage()">{{ $t('SeaExport.Statistics') }}</el-button>
          <!--全部导出Excel-->
          <el-button v-if="$checkPermission(['button_FBAOverseaWarehousing_allExportOverSea'])" no="exportAllToExcel" type="primary" @click="exportAllToExcel()">{{ $t('SeaExport.ExportAllToExcel') }}</el-button>
        </div>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="9300007"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          style="width: 100%;"
          @gridReady="onGridReady"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="9300007"
          :total="total"
          :page.sync="filterJson.pageNum"
          :limit.sync="filterJson.pageSize"
          @pagination="toQueryByPage"
        />
      </div>
      <!-- 入库 -->
      <el-dialog
        v-if="inWarehouse.visible"
        v-el-drag-dialog
        :visible.sync="inWarehouse.visible"
        :title="'入库'"
        width="340px"
        :close-on-click-modal="false"
      >
        <el-form label-width="85px" label-position="left">
          <el-form-item :label="$t('Warehouse.StorageDate')">
            <el-date-picker v-model="inWarehouse.inWarehouseTime" no="inWarehouseTime" type="datetime" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" style="width:100%" :placeholder="$t('SeaExport.SelectTime')" />
          </el-form-item>
          <el-form-item :label="$t('Warehouse.WarehouseName')">
            <cargo-advance-select
              no="warehouseName"
              :select-type="selectTypeNames.basic_data_OverseaWarehouse"
              filterable
              :method-params="{ifFba:false}"
              :clearable="false"
              tag-name="countryEnglishName"
              tag-value="warehouseCode"
              :default-value="inWarehouse.warehouseName"
              style="width:100%;"
              @parentCallBack="p=>{inWarehouse.warehouseName=p.value}"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" style="margin: 0 auto;width: fit-content;">
          <el-button type="primary" @click="toWarehouseIn">{{ $t('common.btn.confirm') }}</el-button>
          <el-button @click="inWarehouse.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </el-dialog>
      <!-- 退件 -->
      <el-dialog
        v-if="returnGoods.visible"
        v-el-drag-dialog
        :visible.sync="returnGoods.visible"
        :title="$t('Warehouse.ReturnGoods')"
        width="340px"
        :close-on-click-modal="false"
      >
        <el-form label-width="85px" label-position="left">
          <el-form-item :label="$t('Warehouse.ReturnGoodsTime')">
            <el-date-picker v-model="returnGoods.returnGoodsTime" no="returnGoodsTime" type="datetime" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" style="width:100%" :placeholder="$t('SeaExport.SelectTime')" />
          </el-form-item>
          <el-form-item :label="$t('Warehouse.ReturnReason')">
            <el-input v-model="returnGoods.returnReason" no="returnReason" style="width:100%" type="textarea" :rows="5" />
          </el-form-item>
        </el-form>
        <div slot="footer" style="margin: 0 auto;width: fit-content;">
          <el-button type="primary" @click="toReturnGoods">{{ $t('common.btn.confirm') }}</el-button>
          <el-button @click="returnGoods.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </el-dialog>
      <!-- 核单 -->
      <el-dialog
        v-if="checklist.visible"
        v-el-drag-dialog
        :visible.sync="checklist.visible"
        :title="$t('Warehouse.Checklist')"
        width="340px"
        :close-on-click-modal="false"
      >
        <el-form label-width="85px" label-position="left">
          <el-form-item :label="$t('Warehouse.ChecklistTime')">
            <el-date-picker v-model="checklist.checklistTime" no="checklistTime" type="datetime" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" style="width:195px" :placeholder="$t('SeaExport.SelectTime')" />
          </el-form-item>
          <el-form-item :label="$t('Warehouse.ChecklistResult')">
            <el-select v-model="checklist.checklistStatus" no="checklistStatus" style="width:195px;" placeholder="">
              <el-option
                v-for="item in SystemConstants.CHECKLIST_STATUS"
                :key="item.code"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Warehouse.HandlingOpinions')">
            <el-input v-model="checklist.comments" type="textarea" :row="5" style="width:195px;" />
          </el-form-item>
        </el-form>
        <div slot="footer" style="margin: 0 auto;width: fit-content;">
          <el-button type="primary" @click="toChecklist">{{ $t('common.btn.confirm') }}</el-button>
          <el-button @click="checklist.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </el-dialog>
      <!-- 登记面单 -->
      <el-dialog
        v-if="registrationSlip.visible"
        v-el-drag-dialog
        :visible.sync="registrationSlip.visible"
        :title="$t('Warehouse.RegistrationSlip')"
        width="540px"
        :close-on-click-modal="false"
      >
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('Warehouse.WarehouseNo')">
            <el-input v-model="registrationSlip.warehouseNo" no="warehouseNo" :disabled="true" style="width:100%" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.mailingAddress.fbaWarehouseCode')">
            <cargo-advance-select
              :disabled="true"
              no="fbaWarehouseCode"
              :select-type="selectTypeNames.basic_data_OverseaWarehouse"
              filterable
              :fields="['warehouseCode']"
              :callback-params="{key:'warehouseCode'}"
              callback-method-type="value"
              tag-value="warehouseCode"
              tag-name="warehouseCode"
              :default-value="registrationSlip.warehouseCode"
              style="width:100%"
              @parentCallBack="item=>registrationSlip.warehouseCode=item.value"
            />
          </el-form-item>
          <!-- 实际件毛体-->
          <el-form-item label-width="0">
            <cargo-ag-grid
              :show-side-bar="false"
              :grid-options="registrationSlip.gridOptions"
              :column-defs="registrationSlip.columnDefs"
              :row-data="registrationSlip.rowData"
              :grid-params.sync="registrationSlip.gridParams"
              style="width: 100%;"
              @gridReady="params=>registrationSlip.gridApi=params.api"
            />
          </el-form-item>
          <el-form-item :label="$t('Warehouse.CourierServicesCompany')">
            <el-input v-model="registrationSlip.expressCompany" no="expressCompany" style="width:100%" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('Warehouse.CourierNumber')">
            <el-input v-model="registrationSlip.courierNumber" no="courierNumber" style="width:100%" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PrintTime')">
            <el-date-picker v-model="registrationSlip.faceOrderPrintTime" no="faceOrderPrintTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" style="width:100%" :placeholder="$t('SeaExport.SelectTime')" />
          </el-form-item>
        </el-form>
        <div slot="footer" style="margin: 0 auto;width: fit-content;">
          <el-button type="primary" @click="toRegistrationSlip">{{ $t('common.btn.confirm') }}</el-button>
          <el-button @click="registrationSlip.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </el-dialog>
      <!-- 装箱 -->
      <el-dialog
        v-if="packing.visible"
        v-el-drag-dialog
        :visible.sync="packing.visible"
        :title="$t('Warehouse.Packing')"
        width="340px"
        :close-on-click-modal="false"
      >
        <el-form label-width="85px" label-position="left">
          <el-form-item :label="$t('SpecialGoods.StuffingTime')">
            <el-date-picker v-model="packing.packingTime" no="packingTime" type="datetime" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" style="width:100%" :placeholder="$t('SeaExport.SelectTime')" />
          </el-form-item>
          <el-form-item :label="$t('Warehouse.RefContainerNo')">
            <el-input v-model="packing.refContainerNo" no="refContainerNo" style="width:100%" />
          </el-form-item>
        </el-form>
        <div slot="footer" style="margin: 0 auto;width: fit-content;">
          <el-button type="primary" @click="toPacking">{{ $t('common.btn.confirm') }}</el-button>
          <el-button @click="packing.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </el-dialog>
      <!-- 出库 -->
      <el-dialog
        v-if="exWarehouse.visible"
        v-el-drag-dialog
        :visible.sync="exWarehouse.visible"
        :title="$t('Warehouse.ExWarehouse')"
        width="400px"
        :close-on-click-modal="false"
      >
        <el-form label-width="100px" label-position="left">
          <el-form-item label-width="0" class="auto-width">
            <el-radio-group v-model="exWarehouse.radioType">
              <el-radio :label="1">{{ '整进整出' }}</el-radio>
            </el-radio-group>
            <el-popover
              placement="bottom"
              width="250"
              trigger="hover"
            >
              <div class="pop-content">{{ '按照订单的维度将未出库的纸箱和托盘全部出库' }}</div>
              <svg-icon slot="reference" icon-class="question" style="font-size: 14px;margin-top: -3px;" />
            </el-popover>
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('Warehouse.DeliveryDate') }}</span>
            <el-date-picker
              v-model="exWarehouse.warehouseOutDate"
              no="warehouseOutDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              style="width:100%"
              :placeholder="$t('SeaExport.SelectTime')"
            />
          </el-form-item>
          <el-form-item :label="'出库备注'">
            <el-input v-model="exWarehouse.remark" no="remark" style="width:100%" type="textarea" :row="12" />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ '操作人' }}</span>
            <cargo-user-select
              no="op"
              :disabled="true"
              :method-params="{}"
              :default-value="exWarehouse.operater||''"
              :merge-load="true"
              style="width:100%"
              @change="p=>{exWarehouse.operater=p.value;}"
            />
          </el-form-item>
          <el-form-item :label="'物流单号(尾程)'">
            <el-input v-model="exWarehouse.logisticsNo" no="refContainerNo" style="width:100%" />
          </el-form-item>
          <el-form-item :label="'预计送达时间'">
            <el-date-picker
              v-model="exWarehouse.preDeliveryTime"
              no="warehouseOutDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              style="width:100%"
              :placeholder="$t('SeaExport.SelectTime')"
            />
          </el-form-item>
          <el-form-item :label="'送达时间'">
            <el-date-picker
              v-model="exWarehouse.deliveryTime"
              :picker-options="pickerOptionsForDeliveryTime"
              no="warehouseOutDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              style="width:100%"
              :placeholder="$t('SeaExport.SelectTime')"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" style="margin: 0 auto;width: fit-content;">
          <el-button type="primary" @click="toExWarehouse">确认</el-button>
          <el-button @click="exWarehouse.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </el-dialog>

      <!-- 统计    -->
      <warehouse-statistics-window
        v-if="statistics.show"
        :visible.sync="statistics.show"
        :warehouses-list="statistics.warehousesList"
      />
      <!-- 查询进仓照片 -->
      <picture-view-window :visible.sync="pictureView.visible" :job="pictureView.j" :model="pictureView.model" :title="pictureView.title" :file-name="pictureView.fileName" :type="pictureView.type" />
    </div>
  </div>
</template>

<script>
import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { WarehouseIn } from '@/class/model/booking/WarehouseIn'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { DocumentManage, stopBubble } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { removeFunc, exportAllToExcelFunc, fbaQueryOversea, updateFields } from '@/api/warehouseIn/warehouseIn'
import warehouseStatisticsWindow from '@/components/Cargo/Warehouse/components/warehousing/warehouseStatisticsWindow'
import convertResToBlob from '@/utils/convertResToBlob'
import pictureViewWindow from '@/components/Cargo/Job/pictureViewWindow'
import { getJobByUuid } from '@/api/booking/job'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import moment from 'moment'
import { getFbaWarehouseInDetail } from '@/api/booking/warehouseInDetail'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import { batchExWarehouse } from '@/api/warehouseIn/outWarehouse'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { FbaWarehouseInUtil } from '@/class/cargo/model/utils/FbaWarehouseInUtil'

export default {
  name: 'FbaOverseaWarehousingTreeGrid',
  components: {
    CargoUserSelect,
    CargoAdvanceSelect,
    CargoGridShowBigContent,
    searchItem,
    cargoTemplateSelectorDialog,
    warehouseStatisticsWindow,
    pictureViewWindow
  },
  props: {
    context: { type: Object, required: true },
    lob: { type: String, required: true }
  },
  data() {
    return {
      SystemConstants,
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      isEditing: false,
      filterJson: {
        pageNum: 1,
        pageSize: 10
      },
      filter: {
        pageNum: 1,
        pageSize: 10,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      // 退件
      returnGoods: {
        visible: false,
        returnGoodsTime: '',
        returnReason: ''
      },
      // 核单
      checklist: {
        visible: false,
        checklistTime: '',
        comments: '',
        checklistStatus: 1
      },
      // 登记打印面单
      registrationSlip: {
        visible: false,
        faceOrderPrintTime: '', // 打印时间
        courierNumber: '', // 快递单号
        expressCompany: '', // 快递公司
        warehouseCode: '', // 仓库代码
        warehouseNo: '', // 进仓编号
        rowData: [],
        gridParams: {},
        columnDefs: [
          { headerName: '件', field: 'boxesNumber', width: 50, colId: 'boxesNumber' },
          { headerName: 'KG', field: 'weight', width: 50, colId: 'weight' },
          { headerName: '长', field: 'boxLength', width: 50, colId: 'boxLength' },
          { headerName: '宽', field: 'boxWidth', width: 50, colId: 'boxWidth' },
          { headerName: '高', field: 'boxHeight', width: 50, colId: 'boxHeight' }
        ],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        },
        gridApi: null
      },
      // 装箱
      packing: {
        visible: false,
        packingTime: '',
        refContainerNo: ''
      },
      pickerOptionsForDeliveryTime: { // 设置可选时间范围
        disabledDate: this.disabledDeliveryTime
      },
      // 出库
      exWarehouse: {
        visible: false,
        radioType: 1,
        selectedRows: [], // 选中数据
        warehouseOutDate: '', // 出库日期
        remark: '', // 备注
        operater: 0, // 操作人
        logisticsNo: '', // 物流单号
        preDeliveryTime: '', // 预计送达时间
        deliveryTime: '' // 送达时间
      },
      // 入库
      inWarehouse: {
        visible: false,
        inWarehouseTime: '',
        warehouseName: ''
      },
      // 图片展示
      pictureView: {
        visible: false,
        title: '',
        model: {},
        fileName: '',
        j: {},
        type: 'WarehouseIn'
      },
      // 统计
      statistics: {
        show: false,
        warehousesList: []
      },
      total: 0,
      selectedData: null,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        onCellDoubleClicked: event => {
          this.toLook(event.data)
        },
        onRowClicked: this.onRowClicked,
        onRowSelected: this.onRowSelected,
        defaultColDef: {
          resizable: true
        },
        onSortChanged: (event) => {
          if (event && event.api && event.api) {
            this.rowData = event.api.getModel().rowsToDisplay.map(item => item.data)
          }
        },
        context: {
          componentParent: this
        }
      },
      export: {},
      rowData: [],
      gridApi: null,
      documentManage: new DocumentManage(),
      templateSelectorDialog: { // 打印弹窗
        visible: false,
        ctx: new WarehouseIn(),
        category: '',
        data: {}
      },
      cbAutoRefresh: true
    }
  },
  computed: {
    isFba() { // 是否fba
      return this.lob === 'FBA'
    },
    columnDefs() {
      return [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', width: 240, colId: 'jobNo', lockVisible: true },
        { headerName: this.$t('FbaChannel.containerNo'), field: 'containerNo', width: 180, colId: 'containerNo' },
        { headerName: this.$t('SeaExport.WarehouseNo'), field: 'warehouseNo', width: 180, colId: 'warehouseNo', lockVisible: true },
        { headerName: this.$t('Pricing.TransportMode'), field: 'shippingType', width: 180, colId: 'shippingType',
          valueFormatter: (params) => {
            return ColumnUtils.shippingTypeLabelFunc(params.value)
          } },
        { headerName: this.$t('Warehouse.WarehouseName'), field: 'warehouse', width: 180, colId: 'warehouse' },
        { headerName: this.$t('Warehouse.StorageDay'), field: 'warehouseInDate', width: 180, colId: 'warehouseInDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Warehouse.DeliveryDay'), field: 'warehouseOutDate', width: 180, colId: 'warehouseOutDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Warehouse.NumberOfCases'), field: 'quantityContract', width: 180, colId: 'quantityContract',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 0, true)
          }
        },
        { headerName: this.$t('Warehouse.Weight'), field: 'weightContract', width: 180, colId: 'weightContract',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 2, true)
          }
        },
        { headerName: this.$t('Warehouse.Volume'), field: 'cubageContract', width: 180, colId: 'cubageContract',
          valueFormatter: (params) => {
            return ColumnUtils.formatNumber(params.value, 3, true)
          }
        },
        { headerName: this.$t('SeaExport.CargoType'), field: 'cargoType', width: 180, colId: 'cargoType',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
          } },
        { headerName: this.$t('SeaExport.CategoryOfGoods'), field: 'cargoCode', width: 180, colId: 'cargoCode',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoInformation, 'code', params.value, 'chineseName')
          } },
        { headerName: this.$t('Warehouse.ServiceChannel'), field: 'serviceChannel', width: 180, colId: 'serviceChannel' },
        { headerName: this.$t('FbaJob.AmazonWarehouseCode'), field: 'warehouseCode', width: 180, colId: 'warehouseCode' },
        { headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'), field: 'customerId', width: 180, colId: 'customerId',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Warehouse.DestinationDeliveryMethod'), field: 'destinationDistribution', width: 180, colId: 'destinationDistribution',
          valueFormatter: (params) => {
            return ColumnUtils.multipleFbaDestinationDistribution(TYPE_NAMES.local_cache_FbaJobConstants$DESTINATION_DISTRIBUTION_LIST, 'code', params.value)
          } },
        { headerName: this.$t('Warehouse.Warehouseman'), field: 'warehouseOp', width: 180, colId: 'warehouseOp',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
          }
        },
        { headerName: 'MBL NO.', field: 'mbl', width: 180, colId: 'mbl' },
        { headerName: this.$t('CargoMsg.Cargo_BoxesInStock'), field: 'zkBoxNum', width: 180, colId: 'zkBoxNum' },
        { headerName: this.$t('CargoMsg.Cargo_PalletsInStock'), field: 'zkPalletNum', width: 180, colId: 'zkPalletNum' },
        { headerName: this.$t('FbaJob.OperationStatusOfForeignWarehouse'), field: 'outWarehouseStatus', width: 180, colId: 'outWarehouseStatus',
          valueFormatter: (params) => {
            return ColumnUtils.outWarehouseStatusLabelFunc(params.value)
          } }
      ]
    }
  },
  async created() {
    await this.preloadBasicData()
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
    this.loading = getLoading()
    this.fbaQueryFunc(true)
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showBusinessInfo', function() {
      context.showBusinessInfo()
    })
    this.documentManage.set('showAttachHandler', function() {
      context.showAttachHandler()
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectedData = null
      if (this.gridApi && event.column) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            const nodeWarehouse = node.data
            if (nodeWarehouse.uuid) this.selectedData = nodeWarehouse
          }
        })
      }
    },
    onGridReady(p) {
      this.gridApi = p.api
    },
    getMAWBLabel() {
      let label = ''
      switch (this.lob) {
        case 'RE':
          label = this.$t('Billing.WayBillNumber')
          break
        case 'AE':
        case 'AI':
          label = 'MAWB'
          break
        case 'SE':
        case 'SI':
          label = 'MB/L'
          break
        case 'FBA':
          label = this.$t('SeaExport.MasterBillNo')
          break
      }
      return label
    },
    // 行首多选框勾选事件
    onRowSelected(event) {
      if (!event || !event.data) return
      this.selectedData = null
      if (event.node.isSelected()) {
        this.onRowClicked(event)
      }
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedData = null
      const node = event.data
      if (node.uuid) this.selectedData = node
    },
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
      this.init()
    },
    init() {},
    // 查询[简单查询/高级查询]
    toQuery() {
      this.filter.pageNum = 1
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery(this.filter.snapshotConditions)
      } else {
        this.toSimpleQuery()
      }
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery(this.filter.snapshotConditions)
      } else {
        this.toSimpleQuery()
      }
    },
    // 高级查询
    toAdvancedQuery(data) {
      this.filter.warehouseNo = ''
      this.filter.conditions = []
      this.filter.lob = this.lob
      if (typeof data !== 'undefined') {
        this.filter.snapshotConditions = [... data] // 高级查询条件（点击查询时的快照状态）
        this.filter.conditions = [... data]
        this.filter.pageNum = 1
      }
      this.filter.pageNum = this.filterJson.pageNum
      this.filter.pageSize = this.filterJson.pageSize
      this.loading = getLoading()
      this.fbaQueryFunc()
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.loading = getLoading()
      if (typeof keyword !== 'undefined') {
        this.filter.warehouseNo = keyword.trim()
        this.filter.pageNum = 1
        this.filter.lob = this.lob
      }
      const conditions = []
      this.filter.conditions = conditions
      this.fbaQueryFunc()
    },
    // fba查询
    fbaQueryFunc(defaultSearch = false) {
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.filter.defaultSearch = defaultSearch
      fbaQueryOversea(this.filter).then(res =>
        this.handleQueryData(res)
      ).finally(() => {
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filterJson.pageNum = res.data.pageNum
      this.filterJson.pageSize = res.data.pageSize
      this.total = Number(res.data.total)
      this.selectedData = null
      if (this.gridApi) this.gridApi.clearFocusedCell()
      if (this.loading) this.loading.close()
    },
    updateListData(res) {
      this.rowData = res
    },
    // 显示进仓图片
    showAttachHandler(e) {
      if (!this.selectedData) {
        this.$message.warning('请选择一条数据！')
        return
      }
      this.pictureView.title = this.$t('Message.ViewWarehouseEntryPhotos')
      this.pictureView.model = this.selectedData
      this.pictureView.fileName = this.selectedData.warehouseNo + '.zip'
      this.pictureView.type = 'WarehouseIn'
      if (this.selectedData.jobUuid) {
        getJobByUuid(this.selectedData.jobUuid).then(res => {
          this.pictureView.j = res.data
          this.pictureView.visible = true
        })
      } else {
        this.pictureView.j = {}
        this.pictureView.visible = true
      }
    },
    // 查看
    toLook(row) {
      row = this.getRowData(row)
      if (!row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      this.$emit('look', row)
    },
    // 新增
    onAdd() {
      this.$emit('add')
    },
    getRowData(row) {
      if (!row) {
        row = this.selectedData
      }
      if (!row) {
        const rows = this.readSelectedRows()
        if (rows && rows.length > 0) {
          row = rows[0]
        }
      }
      return row
    },
    // 编辑
    editHandler(row) {
      row = this.getRowData(row)
      if (!row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      let msg = ''
      if (!row.outWarehouseStatus || Number(row.outWarehouseStatus) === Number(FbaJobConstants.OVERSEA_WAREHOUSE_STATUS_NO_WAREHOUSING.code)) {
        msg = FbaJobConstants.OVERSEA_WAREHOUSE_STATUS_NO_WAREHOUSING.chineseName
      } else if (Number(row.outWarehouseStatus) === Number(FbaJobConstants.OVERSEA_WAREHOUSE_STATUS_ISSUED.code)) {
        msg = FbaJobConstants.OVERSEA_WAREHOUSE_STATUS_ISSUED.chineseName
      }
      if (msg) {
        this.$message.warning(msg + '不允许编辑国外仓信息。')
        return
      }
      this.$emit('edit', row)
    },
    // 删除
    deleteHandler(row) {
      row = this.getRowData(row)
      if (!row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      if (row.instoreFrom) {
        this.$message.info(this.$t('Message.ExternalDataCannotBeDeleted'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToDelete'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        removeFunc({ warehouseInUuid: row.uuid }).then(resp => {
          this.$message.success(this.$t('SeaExport.DeleteSucceeded'))
          this.toQueryByPage()
        }).catch(() => {
          this.loading.close()
        }).finally(() => this.loading.close())
      })
    },
    // 打印
    onPrintHandler() {
      let rows = []
      const selectedRows = this.readSelectedRows()
      if (!this.selectedData && selectedRows.length === 1) {
        rows = this.selectedData
      } else {
        rows = selectedRows
      }
      this.$emit('print', rows)
    },
    // 获取勾选行
    readSelectedRows() {
      return this.gridApi.getSelectedRows()
    },
    // 列表 业务编号旁边搜索框的打印
    showBusinessInfo(e) {
      stopBubble(e)
      if (!this.selectedData) return
      this.templateSelectorDialog.ctx = new WarehouseIn(this.selectedData)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedData.uuid }
      this.templateSelectorDialog.visible = true
    },
    statisticsPage(e) {
      const selectedList = this.readSelectedRows()
      if (!selectedList || selectedList.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      this.statistics.show = true
      this.statistics.warehousesList = selectedList
    },
    exportAllToExcel() {
      this.export = {}
      const data = this.filter.snapshotConditions
      this.export.pageNum = 1
      this.export.pageSize = 10000
      this.export.lob = this.lob
      this.export.conditions = []
      this.export.branchId = this.$store.getters.currentOfficeId
      if (this.isAdvancedQuery) {
        if (typeof data !== 'undefined') {
          this.export.snapshotConditions = [... data] // 高级查询条件（点击查询时的快照状态）
          this.export.conditions = [... data]
        }
      } else {
        this.export.warehouseNo = ''
      }
      this.loading = getLoading()
      exportAllToExcelFunc(this.export).then(res => {
        convertResToBlob(res)
        this.$message.success(this.$t('Message.RequestSucceededExporting'))
        this.loading.close()
      }).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 入库
    onWarehouseIn() {
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      for (const select of selects) {
        if (select.outWarehouseStatus === Number(FbaJobConstants.OVERSEA_WAREHOUSE_STATUS_WAREHOUSING.code) || select.outWarehouseStatus === Number(FbaJobConstants.OVERSEA_WAREHOUSE_STATUS_PARTIAL_DELIVERY.code) || select.outWarehouseStatus === Number(FbaJobConstants.OVERSEA_WAREHOUSE_STATUS_ISSUED.code)) {
          // 已入库/部分出库/已出库  的数据不能入库
          this.$message.warning(this.$t('Warehouse.onWarehouseInCheck'))
          return
        }
      }
      this.inWarehouse.inWarehouseTime = ''
      this.inWarehouse.warehouseName = ''
      this.inWarehouse.visible = true
    },
    // 确定入库
    toWarehouseIn() {
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      if (!this.inWarehouse.inWarehouseTime) {
        this.$message.warning('入库时间' + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.inWarehouse.warehouseName) {
        this.$message.warning(this.$t('Warehouse.WarehouseName') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      this.loading = getLoading()
      const obj = {}
      obj.keys = Array.from(selects, p => p.uuid)
      obj.anyStr = FbaJobConstants.WAREHOUSE_OP_INWAREHOUSE
      obj.anyDate = this.inWarehouse.inWarehouseTime
      obj.anyStr1 = this.inWarehouse.warehouseName
      updateFields(obj).then(res => {
        if (res.data > 0) {
          this.$message.success('入库' + this.$t('Message.Success'))
          for (const cur of selects) {
            cur.warehouseInDate = this.inWarehouse.inWarehouseTime
            cur.warehouse = this.inWarehouse.warehouseName
          }
          this.gridApi.refreshCells({ force: true })
        }
      }).finally(() => {
        this.inWarehouse.visible = false
        this.loading.close()
      })
    },
    // 称重
    async onWeigh(row) {
      row = this.getRowData(row)
      if (!row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      let isContinue = true
      if (row.weighTime) {
        await this.$confirm(this.$t('Warehouse.CheckWeighTime'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
        }).catch(() => {
          isContinue = false
        })
      }
      if (isContinue) {
        row.opType = 'weigh'
        this.$emit('edit', row)
      }
    },
    // 核单-单票/多票【单票进详情、多票走弹框】
    onCheckList(row) {
      row = this.getRowData(row)
      if (!row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      if (selects.length > 1) {
        // 多票走这里
        for (const cur of selects) {
          const isWeigh = this.checkActGoodsDetail(cur)
          if (!isWeigh) {
            // 选择的数据中包含未称重数据，请检查。
            this.$message.warning(this.$t('Warehouse.ChecklistTip'))
            return
          }
        }
        this.checklist.checklistTime = ''
        this.checklist.comments = ''
        this.checklist.checklistStatus = 1
        this.checklist.visible = true
      } else {
        // 单票走这里
        row.opType = 'checklist'
        this.$emit('edit', row)
      }
    },
    // 验证实际货物明细和实际件毛体
    checkActGoodsDetail(cur) {
      let isWeigh = true
      // 实际货物明细条数
      if (!cur.warehouseInDetailCount || cur.warehouseInDetailCount <= 0) {
        isWeigh = false
      }
      // 实际件数
      if (isWeigh && !cur.quantitySum || cur.quantitySum <= 0) {
        isWeigh = false
      }
      // 实际重量
      if (isWeigh && !cur.weightSum || cur.weightSum <= 0) {
        isWeigh = false
      }
      // 实际体积
      if (isWeigh && !cur.cubageSum || cur.cubageSum <= 0) {
        isWeigh = false
      }
      return isWeigh
    },
    // 确定核单
    async toChecklist() {
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      if (!this.checklist.checklistTime) {
        this.$message.warning(this.$t('Warehouse.ChecklistTime') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.checklist.checklistStatus && Number(this.checklist.checklistStatus) !== 0) {
        this.$message.warning(this.$t('Warehouse.ChecklistResult') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      const checklistTime = moment(this.checklist.checklistTime).format('YYYY-MM-DD HH:mm')
      let warehouseNo = ''
      for (const select of selects) {
        if (select.weighTime) {
          const weighTime = moment(select.weighTime).format('YYYY-MM-DD HH:mm')
          if (weighTime > checklistTime) {
            this.$message.warning(this.$t('Warehouse.ChecklistTimeTip', [checklistTime, weighTime]))
            return
          }
        }
        // 判断是否有称重时间
        if (!select.weighTime && !warehouseNo) {
          warehouseNo = select.warehouseNo
        }
      }
      let isContinue = true
      if (warehouseNo) {
        await this.$confirm(this.$t('Warehouse.ChecklistTipOne'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
        }).catch(() => {
          isContinue = false
        })
      }
      if (!isContinue) return
      const obj = {}
      obj.keys = Array.from(selects, p => p.uuid)
      obj.anyStr = FbaJobConstants.WAREHOUSE_OP_CHECKLIST
      obj.anyDate = this.checklist.checklistTime
      obj.anyInteger = this.checklist.checklistStatus
      obj.anyStr1 = this.checklist.comments // 处理意见
      this.loading = getLoading()
      updateFields(obj).then(res => {
        if (res.data > 0) {
          this.$message.success(this.$t('Warehouse.Checklist') + this.$t('Message.Success'))
          for (const cur of selects) {
            cur.checklistTime = this.checklist.checklistTime
            cur.checklistStatus = this.checklist.checklistStatus
          }
          this.gridApi.refreshCells({ force: true })
        }
      }).finally(() => {
        this.checklist.visible = false
        this.loading.close()
      })
    },
    // 退件
    async onReturnGoods() {
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      let isContinue = true
      for (const select of selects) {
        if (select.checklistTime) {
          await this.$confirm(this.$t('Warehouse.ReturnGoodsTips'), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
          }).catch(() => {
            isContinue = false
          })
          break
        }
      }
      if (isContinue) {
        this.returnGoods.returnGoodsTime = ''
        this.returnGoods.returnReason = ''
        this.returnGoods.visible = true
      }
    },
    // 确定退件
    toReturnGoods() {
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      if (!this.returnGoods.returnGoodsTime) {
        this.$message.warning(this.$t('Warehouse.ReturnGoodsTime') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.returnGoods.returnReason) {
        this.$message.warning(this.$t('Warehouse.ReturnReason') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      this.loading = getLoading()
      const obj = {}
      obj.keys = Array.from(selects, p => p.uuid)
      obj.anyStr = FbaJobConstants.WAREHOUSE_OP_RETURNGOODS
      obj.anyDate = this.returnGoods.returnGoodsTime
      obj.anyStr1 = this.returnGoods.returnReason
      updateFields(obj).then(res => {
        if (res.data > 0) {
          this.$message.success(this.$t('Warehouse.ReturnGoods') + this.$t('Message.Success'))
          for (const cur of selects) {
            cur.returnGoodsTime = this.returnGoods.returnGoodsTime
            cur.returnReason = this.returnGoods.returnReason
          }
          this.gridApi.refreshCells({ force: true })
        }
      }).finally(() => {
        this.returnGoods.visible = false
        this.loading.close()
      })
    },
    // 登记面单
    async onRegistrationSlip(row) {
      const cur = this.getRowData(row)
      if (!cur) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      // if (cur.destinationDistribution !== '快递') {
      //   this.$message.warning(this.$t('Warehouse.FaceListCheckExpressDelivery'))
      //   return
      // }
      const isWeigh = this.checkActGoodsDetail(cur)
      let isContinue = true
      if (!isWeigh) {
        await this.$confirm(this.$t('Warehouse.FaceListCheckTip'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
        }).catch(() => {
          isContinue = false
        })
      }
      if (!isContinue) return
      // 实际货物明细
      this.$nextTick(async() => {
        const warehouseInDetail = await getFbaWarehouseInDetail({ warehouseInUuid: cur.uuid }).then(res => res.data)
        this.registrationSlip.rowData = warehouseInDetail || []
      })
      this.registrationSlip.expressCompany = cur.expressCompany
      this.registrationSlip.warehouseCode = cur.warehouseCode
      this.registrationSlip.warehouseNo = cur.warehouseNo
      this.registrationSlip.faceOrderPrintTime = new Date()
      this.registrationSlip.courierNumber = ''
      this.registrationSlip.visible = true
    },
    // 确定登记面单
    toRegistrationSlip() {
      const row = this.getRowData()
      if (!row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      if (!this.registrationSlip.faceOrderPrintTime) {
        this.$message.warning(this.$t('SeaExport.PrintTime') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.registrationSlip.courierNumber) {
        this.$message.warning(this.$t('Warehouse.CourierNumber') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      const obj = {}
      obj.keys = [row.uuid]
      obj.anyStr = FbaJobConstants.WAREHOUSE_OP_REGISTRATIONSLIP
      obj.anyDate = this.registrationSlip.faceOrderPrintTime
      obj.anyStr1 = this.registrationSlip.courierNumber
      this.loading = getLoading()
      updateFields(obj).then(res => {
        if (res.data > 0) {
          this.$message.success(this.$t('Warehouse.RegistrationSlip') + this.$t('Message.Success'))
          row.faceOrderPrintTime = this.registrationSlip.faceOrderPrintTime
          row.courierNumber = this.registrationSlip.courierNumber
          this.gridApi.refreshCells({ force: true })
        }
      }).finally(() => {
        this.registrationSlip.visible = false
        this.loading.close()
      })
    },
    // 装箱
    async onPacking() {
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      let isContinue = true
      for (const select of selects) {
        if (select.returnGoodsTime) { // 包含已退件数据，不能装箱，请核查。
          this.$message.warning(this.$t('Warehouse.PackingTipOne'))
          return
        }
        if ((!select.checklistTime || !select.checklistStatus) && isContinue) { // 这个只要进一次即可
          await this.$confirm(this.$t('Warehouse.PackingTipTwo'), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
          }).catch(() => {
            isContinue = false
          })
        }
      }
      if (isContinue) {
        this.packing.packingTime = ''
        this.packing.refContainerNo = ''
        this.packing.visible = true
      }
    },
    // 确定装箱
    toPacking() {
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      if (!this.packing.packingTime) {
        this.$message.warning(this.$t('SpecialGoods.StuffingTime') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.packing.refContainerNo) {
        this.$message.warning(this.$t('Warehouse.RefContainerNo') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      this.loading = getLoading()
      const obj = {}
      obj.keys = Array.from(selects, p => p.uuid)
      obj.anyStr = FbaJobConstants.WAREHOUSE_OP_PACKING
      obj.anyDate = this.packing.packingTime
      obj.anyStr1 = this.packing.refContainerNo
      updateFields(obj).then(res => {
        if (res.data > 0) {
          this.$message.success(this.$t('Warehouse.Packing') + this.$t('Message.Success'))
          for (const cur of selects) {
            cur.packingTime = this.packing.packingTime
            cur.refContainerNo = this.packing.refContainerNo
          }
          this.gridApi.refreshCells({ force: true })
        }
      }).finally(() => {
        this.packing.visible = false
        this.loading.close()
      })
    },
    // 出库
    onExWarehouse() {
      const selects = this.readSelectedRows()
      if (!selects || selects.length <= 0) {
        this.$message.warning('请勾选需要出库的数据')
        return
      }
      for (const row of selects) {
        if (!row.outWarehouseStatus || Number(row.outWarehouseStatus) === Number(FbaJobConstants.OVERSEA_WAREHOUSE_STATUS_NO_WAREHOUSING.code)) {
          this.$message.warning('选择的数据中包含未入库数据，请检查')
          return
        }
        if (Number(row.outWarehouseStatus) === Number(FbaJobConstants.OVERSEA_WAREHOUSE_STATUS_ISSUED.code)) {
          this.$message.warning('选择的数据中包含已全部出库数据，请检查')
          return
        }
      }
      this.exWarehouse.selectedRows = selects // 选中数据
      this.exWarehouse.warehouseOutDate = '' // 出库日期
      this.exWarehouse.remark = '' // 备注
      this.exWarehouse.operater = this.$store.getters.userId // 操作人
      this.exWarehouse.logisticsNo = '' // 物流单号
      this.exWarehouse.preDeliveryTime = '' // 预计送达时间
      this.exWarehouse.deliveryTime = '' // 送达时间
      this.exWarehouse.visible = true
    },
    // 确定出库
    toExWarehouse() {
      if (!this.exWarehouse.warehouseOutDate) {
        this.$message.warning('出库时间不能为空')
        return
      }
      if (!this.exWarehouse.operater || Number(this.exWarehouse.operater) <= 0) {
        this.$message.warning('操作人不能为空')
        return
      }
      const warehouseOutDate = moment(this.exWarehouse.warehouseOutDate).format('YYYY-MM-DD HH:mm:ss')
      const selectedRows = this.exWarehouse.selectedRows
      for (const selectedRow of selectedRows) {
        if (!selectedRow.warehouseInDate) {
          this.$message.warning('入库时间不能为空')
          return
        }
        const warehouseInDate = moment(selectedRow.warehouseInDate).format('YYYY-MM-DD HH:mm:ss')
        if (warehouseInDate > warehouseOutDate) {
          this.$message.warning('出库时间不能早于入库时间，请检查')
          return
        }
      }
      const fbaOutWarehouse = {}
      fbaOutWarehouse.keys = Array.from(selectedRows, p => p.uuid)
      fbaOutWarehouse.operater = this.exWarehouse.operater
      fbaOutWarehouse.warehouseOutDate = this.exWarehouse.warehouseOutDate
      fbaOutWarehouse.remark = this.exWarehouse.remark
      fbaOutWarehouse.logisticsNo = this.exWarehouse.logisticsNo
      fbaOutWarehouse.preDeliveryTime = this.exWarehouse.preDeliveryTime
      fbaOutWarehouse.deliveryTime = this.exWarehouse.deliveryTime

      const objArr = []
      for (const selectedRow of selectedRows) {
        // 组装参数
        const obj = {}
        obj.anyStr = selectedRow.uuid
        obj.anyStr1 = selectedRow.jobNo
        fbaOutWarehouse.warehouseInDate = selectedRow.warehouseInDate
        fbaOutWarehouse.warehouse = selectedRow.warehouse
        const storageAgeEst = FbaWarehouseInUtil.calStorageAgeEst(fbaOutWarehouse)
        if (storageAgeEst) {
          obj.anyInteger = storageAgeEst.storageAgeDayEst
          obj.anyInteger1 = storageAgeEst.storageAgeWeekEst
        }
        objArr.push(obj)
      }
      fbaOutWarehouse.others = objArr
      this.loading = getLoading()
      batchExWarehouse(fbaOutWarehouse).then(res => {
        const result = res.data
        if (result.success) { // 成功
          this.$message.success('出库' + this.$t('Message.Success'))
          this.toQueryByPage()
          return
        }
        this.$message.error('出库失败：' + result.msg)
      }).finally(() => {
        this.exWarehouse.visible = false
        this.loading.close()
      })
    },
    disabledDeliveryTime(time) {
      return time.getTime() > new Date().getTime()
    }
  }
}
</script>

<style lang="scss">
  #app #verify-tree-grid {
    .not-click {
      pointer-events: none;
      button {
        color: #fff;
        background-color: #8cc8ff;
        border-color: #acbcca;
        cursor: not-allowed;
      }
    }
    button.not-click {
      color: #fff;
      background-color: #8cc8ff;
      border-color: #8cc8ff;
      cursor: not-allowed;
    }

  }
</style>
